if (!customElements.get('slider-centered-products')) {
  customElements.define(
    'slider-centered-products',
    class SliderCenteredProducts extends HTMLElement {
      constructor() {
        super();

        this.container = this.querySelector('.background-slider');
        this.track = this.querySelector('.background-slider__track');
        this.slides = this.querySelectorAll('.background-slider__item');
        
        this.productContainer = this.querySelector('.product-slider');
        this.productTrack = this.querySelector('.product-slider__track');
        this.productSlides = this.querySelectorAll('.product-slider__item');

        this.prevButton = this.querySelectorAll('button[name="previous"]');
        this.nextButton = this.querySelectorAll('button[name="next"]');
        this.paginationButtons = this.querySelectorAll('.slider-counter__link');
        
        this.currentIndex = 0;
        this.totalSlides = this.slides.length;
        this.clonedSlides = false;

        this.slidesPerView = 2;
        this.spaceBetween = 0;

        this.isAnimating = false;
      }

      connectedCallback() {
        this.cloneSlides();
        this.syncBackgroundSliderBounds();
        this.setTrackWidth();
        this.cloneProductSlides();
        this.setProductTrackWidth();

        requestAnimationFrame(() => {
          this.syncBackgroundSliderBounds();
          this.setTrackWidth();
          this.setProductTrackWidth();
          this.goToSlide(this.slidesPerView, false);
          this.updateVisibleSlideClass();
          this.updatePagination();
        });

        this.prevButton.forEach(button =>
          button.addEventListener('click', () => this.handleSlideChange(this.currentIndex - 1))
        );
        this.nextButton.forEach(button =>
          button.addEventListener('click', () => this.handleSlideChange(this.currentIndex + 1))
        );
    
        this.paginationButtons.forEach((button, index) => {
          button.addEventListener('click', () => this.handleSlideChange(index + this.slidesPerView));
        });

        const resizeHandler = () => {
          this.syncBackgroundSliderBounds();
          this.setTrackWidth();
          this.setProductTrackWidth();
          
          requestAnimationFrame(() => {
            this.goToSlide(this.currentIndex, false);
          });
        };

        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(resizeHandler, 200);
        });

        this.track.addEventListener('transitionend', () => {
          if (this.currentIndex === 0) {
            setTimeout(() => this.goToSlide(this.totalSlides, false), 150);
          } else if (this.currentIndex === this.totalSlides + this.slidesPerView) {
            setTimeout(() => this.goToSlide(this.slidesPerView, false), 150);
          }
          this.isAnimating = false;
        });
      }

      cloneSlides() {
        const firstSlides = Array.from(this.slides).slice(0, this.slidesPerView).map(slide => slide.cloneNode(true));
        const lastSlides = Array.from(this.slides).slice(-this.slidesPerView).map(slide => slide.cloneNode(true));

        firstSlides.forEach(slide => this.track.appendChild(slide));
        lastSlides.forEach(slide => this.track.insertBefore(slide, this.slides[0]));

        this.slides = this.track.querySelectorAll('.background-slider__item');
        this.clonedSlides = true;
      }

      cloneProductSlides() {
        const firstSlides = Array.from(this.productSlides).slice(0, this.slidesPerView).map(slide => slide.cloneNode(true));
        const lastSlides = Array.from(this.productSlides).slice(-this.slidesPerView).map(slide => slide.cloneNode(true));
      
        firstSlides.forEach(slide => this.productTrack.appendChild(slide));
        lastSlides.forEach(slide => this.productTrack.insertBefore(slide, this.productSlides[0]));
      
        this.productSlides = this.productTrack.querySelectorAll('.product-slider__item');
        this.clonedSlides = true;
      }

      syncBackgroundSliderBounds() {
        if (!this.container || !this.productContainer) return;

        if (window.innerWidth < 750) {
          this.container.style.width = '';
          this.container.style.left = '';
          this.container.style.transform = 'translateY(-50%)';
          return;
        }

        const sliderRect = this.getBoundingClientRect();
        const productRect = this.productContainer.getBoundingClientRect();

        this.container.style.width = `${productRect.width}px`;
        this.container.style.left = `${productRect.left - sliderRect.left}px`;
        this.container.style.right = 'auto';
        this.container.style.transform = 'translateY(-50%)';
      }

      setTrackWidth() {

        if (!this.container.clientWidth) return;
        
        const slideWidth = this.container.clientWidth / this.slidesPerView - this.spaceBetween;
        const totalWidth = (slideWidth + this.spaceBetween) * this.slides.length;
        
        this.track.style.width = `${totalWidth}px`;

        this.slides.forEach(slide => {
          slide.style.flex = `0 0 ${slideWidth}px`;
        });
      }

      setProductTrackWidth() {
        if (!this.productContainer.clientWidth) return;
        
        const productWidth = this.productContainer.clientWidth;
        const totalWidth = productWidth * this.productSlides.length;

        this.productTrack.style.width = `${totalWidth}px`;

      }

      handleSlideChange(index) {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.goToSlide(index);
      }

      goToSlide(index, transition = true) {
        if (!transition) {
          this.track.style.transition = 'none';
          this.productTrack.style.transition = 'none';
        } else {
          this.track.style.transition = 'transform 0.5s ease-in-out';
          this.productTrack.style.transition = 'transform 0.5s ease-in-out .1s';
        }

        this.currentIndex = index;
        const offset = this.getCenteredOffset(index);
        this.track.style.transform = `translateX(${offset}px)`;

        const offsetProduct = -(index * this.productSlides[0].clientWidth);
        this.productTrack.style.transform = `translateX(${offsetProduct}px)`;

        this.updateVisibleSlideClass();
        this.updatePagination();

        if (!transition) {
          setTimeout(() => this.track.style.transition = 'transform 0.5s ease-in-out', 50);
          setTimeout(() => this.productTrack.style.transition = 'transform 0.5s ease-in-out .1s', 50);
        }
      }

      getCenteredOffset(index) {
        const visibleWidth = this.container.clientWidth;
        const slideWidth = this.slides[0].clientWidth;
        const totalOffset = index * (slideWidth + this.spaceBetween);
        const centeredOffset = totalOffset - (visibleWidth / 2 - slideWidth / 2);
        return -centeredOffset;
      }

      updateVisibleSlideClass() {
        const prevIndex = this.currentIndex - 1;
        const nextIndex = this.currentIndex + 1;

        this.slides.forEach((slide, i) => {
          slide.classList.remove('slide-visible-bg', 'slide-adjacent-left', 'slide-adjacent-right');

          if (i === this.currentIndex) {
            slide.classList.add('slide-visible-bg');
          } else if (i === prevIndex) {
            slide.classList.add('slide-adjacent-left');
          } else if (i === nextIndex) {
            slide.classList.add('slide-adjacent-right');
          }
        });

        this.productSlides.forEach(slide => slide.classList.remove('slide-visible'));
        this.productSlides[this.currentIndex]?.classList.add('slide-visible');
      }

      updatePagination() {
        const originalIndex = (this.currentIndex - this.slidesPerView + this.totalSlides) % this.totalSlides;
        
        this.paginationButtons.forEach((button, index) => {
          button.classList.toggle('active', index === originalIndex);
        });
      }
    }
  )
}